import { matchPath, resolvePath, Location } from "react-router-dom";

//TODO(nibeauli): explain this indecipherable mess
export function isActiveRoute(location: Location, queryPath: string, activePathName: string | undefined) {
  if (activePathName === undefined) return false;
  const path = resolvePath(queryPath, activePathName);
  return matchPath(location.pathname, path.pathname) !== null;
}
